module.exports = __webpack_public_path__ + "static/media/teaching_right_for_you_hero.56f70746.png";